import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { push } from "connected-react-router";
import downloadFile from "../../../lib/utils/downloadFile";
import ModalActions from "../../../redux/reducers/modal.reducer";

/**
 * Hook para manejar acciones del historial de pagos.
 * Centraliza navegación y descarga de derechos patrimoniales.
 */
export const usePaymentHistoryActions = () => {
  const dispatch = useDispatch();

  const handleBack = useCallback(() => {
    dispatch(push("/my-payments"));
  }, [dispatch]);

  const handleDownload = useCallback(
    (payment) => {
      if (payment.equity_rights_url) {
        downloadFile(payment.equity_rights_url, false);
      } else {
        dispatch(
          ModalActions.setConditionalModalState(true, "ErrorModal", {
            title: "Error",
            content: "No se pudo descargar el archivo de derechos patrimoniales"
          })
        );
      }
    },
    [dispatch]
  );

  return {
    handleBack,
    handleDownload
  };
};
